import { ComponentProps } from 'react';
import { Button as DefaultButton, Spinner } from 'react-bootstrap';

import styles from './button.module.scss';
import classNames from 'classnames';

type ButtonProps = ComponentProps<typeof DefaultButton>;
type ButtonWithProcessingProps = ButtonProps & {
    isProcessing?: boolean;
};

export const Button: React.FC<ButtonWithProcessingProps> = ({ children, isProcessing, className, ...props }) => (
    <DefaultButton {...props} className={classNames(className, styles.button)} >
        {isProcessing
            ? (
                <Spinner animation="border" role="status" size='sm'>
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            )
            : children}
    </DefaultButton>
)
